// extracted by mini-css-extract-plugin
export default {"colorInput":"colorInput--_olYN"};